<template>
  <ModalVue :fields="[
    {
      name: 'message',
      tag: 'ta',
      req: true,
      placeholder: 'wiadomość'
    }
  ]" title="wyślij wiadomość" :is-visible="isMessageModalVisible" button-text="wyślij"
            @closeModal="() => { isMessageModalVisible = false }" @sendData="(data) => sendMessage(data)" />

  <ModalVue :fields="[
    {
      name: 'rate',
      tag: 'select',
      options: [
        { name: '1', value: '1' },
        { name: '2', value: '2' },
        { name: '3', value: '3' },
        { name: '4', value: '4' },
        { name: '5', value: '5' },
        { name: '6', value: '6' },
        { name: '7', value: '7' },
        { name: '8', value: '8' },
        { name: '9', value: '9' },
        { name: '10', value: '10' },
      ],
    }, {
      name: 'calendar_item_id',
      tag: 'select',
      options: calendarItems,
    }
  ]" title="wystaw ocenę" :is-visible="isRateModalVisible" button-text="wystaw"
            @closeModal="() => { isRateModalVisible = false }" @sendData="(data) => sendRate(data)" />

  <EmailPreviewModalVue @closeEmailModal="() => isEmailModalVisible = false" :email="user ? user.email : null"
                        :isVisible="isEmailModalVisible" />

  <div class="card-container" v-if="user">
    <section class="card-container__hero">
      <img class="card-container__hero__img" :src="userImage ? userImage : getImageUrl()" alt="zdjęcie profilu">

      <div class="card-container__hero__main">
        <div class="card-container__hero__title-row">
          <h1>{{ user.name }}</h1>
          <div class="rating-badge" v-if="reviews">
            <img src="@/assets/icons/star-fill.svg" alt="" v-for="item in Math.round(reviews.average)" :key="item">
            <span>{{ reviews.average }}/10</span>
          </div>
        </div>

        <h2>{{ user.firstname }} {{ user.lastname }}</h2>

        <p class="meta-line" v-if="user.category">
          {{ user.category.name }}
          <span v-if="user.role_id === 4"> • pracownik w {{ bizName }}</span>
        </p>

        <div class="meta-line" v-if="specFirmList && specFirmList.length > 0">
          <span>Placówki:</span>
          <span class="chips">
            <a v-for="firm in specFirmList" :key="firm.id"
               :href="$router.resolve(`/browse/user/${firm.firm.id}`).href">{{ firm.firm.name }}</a>
          </span>
        </div>
      </div>

      <aside class="card-container__hero__actions" v-if="!(user.role_id === 4 || user.role_id === 5)">
        <ButtonVue text="Skontaktuj się" bg-color="#10b981" color="#ffffff" @click="() => openMessageModal()" />
        <ButtonVue v-if="currentUser" text="Wystaw ocenę" bg-color="#FFCE32" color="#002F34"
                   @click="() => openRateModal()" />
      </aside>
    </section>

    <section class="card-container__content">
      <aside class="card-container__sidebar">
        <div class="info-card">
          <h3>Kontakt</h3>
          <span v-if="user.address"><img src="@/assets/icons/geo-alt.svg" alt="adres">{{ user.address }}</span>
          <span v-if="user.phone"><img src="@/assets/icons/telephone.svg" alt="telefon">{{ user.phone }} <br> {{ user.phone_2 }}</span>
          <span role="button" class="email-link" @click="() => isEmailModalVisible = true" v-if="user.email">
            <img src="@/assets/icons/envelope.svg" alt="email">pokaż e-mail
          </span>
        </div>

        <div class="info-card" v-if="user.terms_and_conditions_url || user.privacy_policy_url">
          <h3>Dokumenty</h3>
          <a target="blank" v-if="user.terms_and_conditions_url" :href="user.terms_and_conditions_url">regulamin</a>
          <a target="blank" v-if="user.privacy_policy_url" :href="user.privacy_policy_url">polityka prywatności</a>
        </div>
      </aside>

      <main class="card-container__main">
        <p class="card-container__main__short-desc" v-if="user.short_description">{{ user.short_description }}</p>
        <p class="card-container__main__desc" v-if="user.description">{{ user.description }}</p>

        <div class="services-toolbar" v-if="services">
          <div class="view-switcher">
            <button aria-label="widok siatki" :class="servicesView === 1 ? 'selected' : ''" @click="servicesView = 1">
              <img src="@/assets/icons/grid.svg" alt="siatka">
            </button>
            <button aria-label="widok listy" :class="servicesView === 2 ? 'selected' : ''" @click="servicesView = 2">
              <img src="@/assets/icons/list.svg" alt="lista">
            </button>
          </div>

          <div class="search-box">
            <input type="text" name="searchInput" id="searchInput" placeholder="tytuł usługi" v-model="searchInput">
            <button @click="findService()">
              <img src="@/assets/icons/search.svg" alt="szukaj">
            </button>
            <button @click="() => {
              getUserServices();
              searchInput = ''
            }">reset</button>
          </div>
        </div>

        <h3 v-if="services" class="section-title">
          <span v-if="services.length > 0">Wybierz usługę:</span>
          <span v-else>Nie znaleziono usług</span>
        </h3>

        <ServiceModal />

        <div class="services-grid" v-if="services && states.length > 0 && servicesView === 1">
          <ServiceCardVue v-for="service in services" :key="service.service.id" :price="service.service.price"
                          :img="service.service.photo_url" :is-advance="!!service.service.advanceAmount"
                          :name="service.service.name" :state="states.filter(state => state.value === service.service.state_id)[0].name"
                          :ishighlighted="service.service.active"
                          @openServiceModal="() => $router.push({ path: `/browse/user/${$route.params.userId}`, query: { serviceID: service.service.id } })" />
        </div>

        <div class="services-list" v-if="services && states.length > 0 && servicesView === 2">
          <div class="services-list__item" v-for="service in services" :key="service.service.id">
            <div class="services-list__left">
              <span>{{ service.service.name }}</span>
              <img v-if="service.service.advanceAmount" class="advance-icon" src="@/assets/icons/cash.svg"
                   alt="usługa z zaliczką">
              <span>{{ service.service.price }} zł</span>
            </div>
            <button
                @click="() => $router.push({ path: `/browse/user/${$route.params.userId}`, query: { serviceID: service.service.id } })">
              szczegóły
            </button>
          </div>
        </div>

        <h3 v-if="firmSpecsList && firmSpecsList.length > 0" class="section-title">Specjaliści:</h3>
        <div class="specs-grid" v-if="firmSpecsList && firmSpecsList.length > 0">
          <div class="spec-item" v-for="spec in firmSpecsList" :key="spec.id">
            <img src="@/assets/photo-placeholder.png" alt="brak zdjęcia">
            <a :href="$router.resolve(`/browse/user/${spec.business.id}`).href">
              {{ spec.business.firstname }} {{ spec.business.lastname }}
            </a>
          </div>
        </div>
      </main>
    </section>
  </div>
</template>

<script>
import axios from 'axios';
import { useMeta } from 'vue-meta';
import ButtonVue from '@/components/Button.vue';
import ServiceCardVue from '@/components/SpecialComponents/ServiceCard.vue';
import ModalVue from '@/components/Modal.vue';
import authHeader from '@/services/auth-header';
import ServiceModal from '@/components/SpecialComponents/ServiceModal.vue';
import EmailPreviewModalVue from '@/components/SpecialComponents/EmailPreviewModal.vue';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'BusinessCardVue',
  setup() {
    useMeta({ title: 'usługodawca' })

    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    }
  },
  data() {
    return {
      user: null,
      userImage: null,
      reviews: null,
      services: null,
      states: [],
      isMessageModalVisible: false,
      isRateModalVisible: false,
      bizName: '',
      isEmailModalVisible: false,
      firmSpecsList: null,
      specFirmList: null,
      servicesView: 2,
      searchInput: '',
      calendarItems: []
    }
  },
  created() {
    this.getUserData()
    if (this.currentUser) {
      this.calendarItems = this.currentUser.notRatedVisits.map(ci => ({ name: 'Wizyta z dnia: ' + ci.date, value: ci.id }));
    }
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  components: { ButtonVue, ServiceCardVue, ModalVue, ServiceModal, EmailPreviewModalVue },
  methods: {
    getImageUrl() {
      return new URL(`../assets/photo-placeholder.png`, import.meta.url).href;
    },
    getUserServices() {
      axios.get(`/UserService/${this.$route.params.userId}`).then(res => {
        this.services = res.data
      })
    },
    getUserData() {
      axios.get(`/User/${this.$route.params.userId}`).then(res => {
        if (res.data.role_id === 3) {
          this.$router.push('/')
        } else if (res.data.role_id === 2) {
          this.user = res.data
          axios.get(`/UserImage/${res.data.id}`).then(resp => {
            if (resp.data.length > 0) {
              this.userImage = resp.data[0].photo_url
            }
          })

          axios.post('/ReviewUserSearch', { page: 1, limit: 50, user_id: res.data.id }).then(respn => {
            this.reviews = respn.data
          })

          axios.get(`/UserService/${res.data.id}`).then(respns => {
            this.services = respns.data
          })

          axios.get(`/FrontendFirmBusinessSpecialistList/${this.$route.params.userId}`).then(respon => {
            this.specFirmList = respon.data.items
          })

          axios.get('/State').then(res => {
            res.data.forEach((item) => {
              const ob = {
                name: item.name,
                value: `${item.id}`
              }
              this.states.push(ob)
            })
          })
        } else if (res.data.role_id === 4) {
          this.user = res.data

          axios.get(`/UserImage/${res.data.id}`).then(res => {
            if (res.data.length > 0) {
              this.userImage = res.data[0].photo_url
            }
          })

          axios.post('/ReviewUserSearch', { page: 1, limit: 50, user_id: res.data.id }).then(res => {
            this.reviews = res.data
          })

          axios.get(`/UserService/${res.data.main_id}`).then(res => {
            this.services = res.data.filter(service => service.service.employee_id === res.data.id)
          })

          axios.get(`/User/${res.data.main_id}`).then(res => {
            this.bizName = res.data.name
          })

          axios.get('/State').then(res => {
            res.data.forEach((item) => {
              const ob = {
                name: item.name,
                value: `${item.id}`
              }
              this.states.push(ob)
            })
          })
        } else if (res.data.role_id === 5) {
          this.user = res.data
          axios.get(`/UserImage/${res.data.id}`).then(resp => {
            if (resp.data.length > 0) {
              this.userImage = resp.data[0].photo_url
            }
          })
          axios.get(`/FrontendFirmBusinessList/${this.$route.params.userId}`).then(respon => {
            this.firmSpecsList = respon.data.items
          })
        }
      })
    },
    openMessageModal() {
      if (this.currentUser) {
        if (this.currentUser.id !== 3) {
          this.isMessageModalVisible = true
        } else {
          this.appStore.setIsAlert('Jesteś usługodawcą i nie możesz wysyłać wiadomości')
        }
      } else {
        this.appStore.setIsAlert('Musisz być zalogowany/a')
      }
    },
    openRateModal() {
      if (this.currentUser) {
        if (this.currentUser.id !== 3) {
          this.isRateModalVisible = true
        } else {
          this.appStore.setIsAlert('Jesteś usługodawcą i nie możesz wystawiać ocen')
        }
      } else {
        this.appStore.setIsAlert('Musisz być zalogowany/a')
      }
    },
    sendMessage(data) {
      if (data) {
        const ob = {
          title: this.currentUser.name,
          content: data.message,
          from_id: this.currentUser.id,
          to_id: this.$route.params.userId
        }
        axios.post('/Message', ob, authHeader())
            .then(res => {
              if (String(res.status).charAt(0) === '2') {
                this.appStore.setIsSuccess('Wysłano wiadomość')
              }
            })
      }
    },
    sendRate(data) {
      const ob = {
        name: this.currentUser.name,
        content: `ocena ${data.rate}`,
        rating: data.rate,
        from_user_id: this.currentUser.id,
        user_id: this.$route.params.userId,
        calendar_item_id: data.calendar_item_id
      }
      axios.post(`/ReviewUser`, ob, authHeader())
          .then(res => {
            if (String(res.status).charAt(0) === '2') {
              this.appStore.setIsSuccess('Pomyślnie wystawiono ocenę')
            }
          })
    },
    findService() {
      if (this.searchInput && this.searchInput.length > 2) {
        this.services = this.services.filter(service => service.service.name.includes(this.searchInput))
      } else {
        this.appStore.setIsAlert('Wpisz tytuł szukanej usługi (co najmniej 3 litery)')
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.advance-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  opacity: .75;
}

.card-container {
  --bg: #f2f4f5;
  --card: #ffffff;
  --border: #d8dfe3;
  --text: #002f34;
  --muted: #5f7a7d;
  --primary: #23e5db;
  --primary-dark: #00a49f;
  --accent: #ffce32;
  --shadow: 0 8px 24px rgba(0, 47, 52, .08);

  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: 14px;
  box-shadow: var(--shadow);
  overflow: hidden;
  color: var(--text);

  &__hero {
    display: grid;
    grid-template-columns: 124px 1fr 260px;
    gap: 20px;
    padding: 24px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfb 100%);
    border-bottom: 1px solid var(--border);

    &__img {
      width: 124px;
      height: 124px;
      border-radius: 12px;
      object-fit: cover;
      border: 1px solid var(--border);
      background: #fff;
    }

    &__main {
      min-width: 0;

      .card-container__hero__title-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        flex-wrap: wrap;
      }

      h1 {
        margin: 0;
        font-size: 2rem;
        line-height: 1.2;
        font-weight: 700;
        color: var(--text);
      }

      h2 {
        margin: 8px 0 0;
        font-size: 1.5rem;
        font-weight: 600;
        color: var(--muted);
      }

      .meta-line {
        margin: 10px 0 0;
        font-size: 1.35rem;
        line-height: 1.45;
        color: var(--text);
      }

      .chips {
        display: inline-flex;
        gap: 8px;
        flex-wrap: wrap;
        margin-left: 8px;
      }

      .chips a {
        display: inline-flex;
        align-items: center;
        background: #fff;
        border: 1px solid var(--border);
        border-radius: 999px;
        padding: 4px 10px;
        font-size: 1.25rem;
        text-decoration: none;
        color: #3a77ff;
        font-weight: 600;
      }

      .chips a:hover {
        background: #f4f8ff;
      }
    }

    &__actions {
      display: flex;
      flex-direction: column;
      gap: 10px;
      align-self: start;

      :deep(button) {
        width: 100%;
        min-height: 44px;
        border-radius: 10px !important;
        font-size: 1.4rem !important;
        font-weight: 700;
      }
    }
  }

  &__content {
    display: grid;
    grid-template-columns: 290px 1fr;
  }

  &__sidebar {
    border-right: 1px solid var(--border);
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    background: #fff;
  }

  &__main {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: #fff;

    &__short-desc {
      margin: 0;
      font-size: 2rem;
      line-height: 1.3;
      font-weight: 700;
      color: var(--text);
    }

    &__desc {
      margin: 0;
      font-size: 1.4rem;
      line-height: 1.65;
      color: #24484c;
      white-space: pre-line;
    }
  }
}

.info-card {
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 14px;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 10px;

  h3 {
    margin: 0;
    font-size: 1.45rem;
    color: var(--text);
  }

  span {
    display: flex;
    align-items: flex-start;
    gap: 9px;
    font-size: 1.3rem;
    line-height: 1.45;
    color: var(--text);
  }

  span img {
    width: 16px;
    height: 16px;
    opacity: .75;
    margin-top: 2px;
  }

  a {
    color: #3a77ff;
    text-decoration: none;
    font-weight: 600;
    width: fit-content;
  }

  a:hover {
    text-decoration: underline;
  }

  .email-link {
    cursor: pointer;
    color: #3a77ff;
    font-weight: 600;
  }
}

.rating-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border: 1px solid var(--border);
  background: #fff;
  border-radius: 999px;
  padding: 4px 10px;

  img {
    width: 15px;
    height: 15px;
  }

  span {
    margin-left: 4px;
    font-size: 1.25rem;
    font-weight: 700;
    color: var(--text);
  }
}

.services-toolbar {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 10px;
  background: #f9fbfb;
  flex-wrap: wrap;
}

.view-switcher {
  display: inline-flex;
  gap: 6px;

  button {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid var(--border);
    background: #fff;
    cursor: pointer;

    img {
      width: 18px;
      height: 18px;
      opacity: .7;
    }
  }

  button.selected {
    background: #002f34;
    border-color: #002f34;

    img {
      filter: brightness(0) invert(1);
      opacity: 1;
    }
  }
}

.search-box {
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 6px;
  flex: 1;
  min-width: 270px;

  input {
    min-height: 40px;
    border: 1px solid var(--border);
    border-radius: 8px;
    padding: 0 12px;
    font-size: 1.35rem;
    outline: none;
  }

  input:focus {
    border-color: var(--primary-dark);
    box-shadow: 0 0 0 3px rgba(35, 229, 219, .2);
  }

  button {
    min-height: 40px;
    border: 1px solid var(--border);
    border-radius: 8px;
    padding: 0 12px;
    background: #fff;
    cursor: pointer;
    font-weight: 600;
    color: var(--text);
  }

  button:hover {
    background: #f3f7f8;
  }

  button img {
    width: 16px;
    height: 16px;
  }
}

.section-title {
  margin: 0;
  font-size: 1.55rem;
  color: var(--text);
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 14px;
}

.services-list {
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  min-width: 0;

  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 12px;
    border-bottom: 1px solid #edf1f2;
    min-height: 56px;
    min-width: 0;
  }

  &__item:last-child {
    border-bottom: none;
  }

  &__left {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
  }

  &__left span:first-child {
    font-weight: 600;
    color: var(--text);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__left span:last-child {
    color: var(--muted);
    font-weight: 700;
  }

  button {
    background: #fff;
    border: 1px solid #002f34;
    color: #002f34;
    border-radius: 8px;
    padding: 7px 12px;
    cursor: pointer;
    font-weight: 700;
    white-space: nowrap;
  }

  button:hover {
    background: #002f34;
    color: #fff;
  }
}

.specs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: 12px;
}

.spec-item {
  border: 1px solid var(--border);
  border-radius: 12px;
  background: #fff;
  padding: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  img {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid var(--border);
  }

  a {
    text-align: center;
    color: #3a77ff;
    text-decoration: none;
    font-weight: 600;
  }

  a:hover {
    text-decoration: underline;
  }
}

@media (max-width: 980px) {
  .card-container {
    &__hero {
      grid-template-columns: 96px 1fr;
      padding: 16px;

      &__img {
        width: 96px;
        height: 96px;
      }

      &__actions {
        grid-column: 1 / -1;
      }
    }

    &__content {
      grid-template-columns: 1fr;
    }

    &__sidebar {
      border-right: none;
      border-bottom: 1px solid var(--border);
      padding: 14px;
    }

    &__main {
      padding: 14px;
    }
  }
}

@media (max-width: 640px) {
  .card-container {
    overflow-x: hidden;

    &__main {
      min-width: 0;
    }
  }

  .services-toolbar {
    align-items: stretch;
  }

  .view-switcher {
    width: 100%;
  }

  .search-box {
    grid-template-columns: 1fr;
    min-width: 0;
    width: 100%;
  }

  .services-list {
    min-width: 0;
  }

  .services-list__item {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }

  .services-list__left {
    width: 100%;
    min-width: 0;
    flex-wrap: wrap;
    row-gap: 6px;
  }

  .services-list__left span:first-child {
    white-space: normal;
    overflow: visible;
    text-overflow: clip;
    word-break: break-word;
    overflow-wrap: anywhere;
    width: 100%;
  }

  .services-list__item button {
    width: 100%;
  }
}
</style>